const $form_archives = $('#archives-form');

$('select#arch_period').on('change', function () {
    const period = this.value;

    if (period == '') {
        $('#brochure, #spreadsheet').attr('disabled', 'disabled');
        return;
    }

    $('#brochure, #spreadsheet, #zip').removeAttr('disabled').prop('checked', false);

    const brochureLink = $('#' + period).attr('data-brochure');
    const spreadsheetLink = $('#' + period).attr('data-spreadsheet');
    const zipLink = $('#' + period).attr('data-zip');

    $('#brochure').val(brochureLink);
    $('#spreadsheet').val(spreadsheetLink);
    $('#zip').val(zipLink);

    if (brochureLink == '') {
        $('#brochure').attr('disabled', 'disabled');
    }

    if (spreadsheetLink == '') {
        $('#spreadsheet').attr('disabled', 'disabled');
    }
});

$('#downloader', $form_archives).on('click', function (e) {
    e.preventDefault();

    const brochureLink = $('#brochure').val();
    const spreadsheetLink = $('#spreadsheet').val();
    const zipLink = $('#zip').val();

    if ($('#brochure').is(':checked') && !$('#spreadsheet').is(':checked')) {
        var url = brochureLink;
        var link = document.createElement('a');
        link.href = url;
        link.download = url.substr(url.lastIndexOf('/') + 1);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    if ($('#spreadsheet').is(':checked') && !$('#brochure').is(':checked')) {
        var url = spreadsheetLink;
        var link = document.createElement('a');
        link.href = url;
        link.download = url.substr(url.lastIndexOf('/') + 1);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    if ($('#brochure').is(':checked') && $('#spreadsheet').is(':checked')) {
        var url = zipLink;
        var link = document.createElement('a');
        link.href = url;
        link.download = url.substr(url.lastIndexOf('/') + 1);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
});